<template>
	<div>
		<v-row class="ma-0">
			<v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 6" class="pl-0">
				<v-btn block outlined class="text-capitalize" color="#82899B" @click="onBack()">
					<v-icon class="mr-2">mdi-arrow-left</v-icon>
					Back to list
				</v-btn>
			</v-col>
			<v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 6" class="pr-0">
				<v-btn block elevation="0" class="text-capitalize white--text" color="#82899B">
					Save changes
				</v-btn>
			</v-col>
		</v-row>
		<v-card class="pa-4" color="#FAFAFA">
			<div class="title-text">Public Holiday name</div>
			<v-text-field
				style="min-width: 240px; max-width: 30%;"
				v-model="holiday_name"
				outlined
				dense
				clearable
				hide-details
			/>
			<div class="title-text mt-3">Recurrence type</div>
			<v-btn-toggle v-model="holiday_recurrency" dense>
				<v-btn
					class="text-capitalize"
					:class="item.value === holiday_recurrency ? 'white--text':'text-color'"
					v-for="item of recurrences" 
					:key="item.key" 
					:color="item.value === holiday_recurrency ? color : '#82899B'"
					:outlined="item.value !== holiday_recurrency"
					dense
				>
					{{ item.text }}
				</v-btn>
			</v-btn-toggle>
			<div v-for="item of recurrences" :key="item.key">
				<span class="comment-text mt-1" v-if="item.value === holiday_recurrency">{{ item.comment }}</span>
			</div>
			<v-row class="ma-0">
				<v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 3" class="pl-0">
					<div class="title-text">Day</div>
					<v-select
						v-model="holiday_day"
						:items="days"
						outlined
						dense
						hide-details
					></v-select>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 3" class="pr-0">
					<div class="title-text">Month</div>
					<v-select
						v-model="holiday_month"
						:items="month_list"
						outlined
						dense
						hide-details
					></v-select>
				</v-col>
			</v-row>
			<v-checkbox
				class="mt-0"
				v-model="is_recurrences"
				label="Send reminder when there are 0 or 1 recurrences of this Public Holiday."
				:color="color"
				hide-details
			>
			</v-checkbox>
			<v-checkbox
				class="mt-0"
				v-model="is_move_next"
				label="If Public Holiday falls on a Saturday or Sunday, move it to the next working day."
				:color="color"
				hide-details
			>
			</v-checkbox>
			<div class="title-text mt-3" style="color: #605AF6">Countries</div>
			<v-row class="ma-0" no-gutters>
				<v-col cols="12">
					<span class="comment-text">Select the countries and/or states and regions that this public holiday applies to.</span>
				</v-col>
				<v-col cols="12">
					<span class="comment-text">Eg., Christmas is a public holiday in Australia and the United Kingdom, so Australia and United Kingdom should be selected.</span>
				</v-col>
			</v-row>
			<v-text-field
				:color="color"
				outlined
				dense
				hide-details
			>
				<template v-slot:prepend-inner>
					<v-row class="ma-0">
						<div v-for="(item) in select_country_items" :key="item.id">
							<v-chip
								style="margin: 1px"
								small
								label
								close
								close-icon="$close"
								@click:close="remove(item)"
							>
								{{ item.name }}
							</v-chip>
						</div>
					</v-row>
				</template>
			</v-text-field>
			
			<v-btn-toggle
				v-model="country_select"
				group
			>
				<v-btn class="text-capitalize" :color="color" text value="select" @click="onSelectAll()">Select all</v-btn>
				<v-btn class="text-capitalize" :color="color" text value="deselect" @click="onDeselectAll()">Deselect all</v-btn>
				<v-btn class="text-capitalize" :color="color" text value="expand" @click="onExpandAll()">Expand all</v-btn>
				<v-btn class="text-capitalize" :color="color" text value="collapse" @click="onCollapseAll()">Collapse all</v-btn>
			</v-btn-toggle>
			<v-card style="height: 300px" elevation="0" color="#FFFFFF">
				<div style="height: 96%; overflow: auto;">
					<v-treeview
						v-model="select_country_items"
						:items="country_items"
						:open.sync="open"
						selectable
						return-object
						dense
						expand-icon="mdi-chevron-down"
					>
						<template v-slot:prepend="{ item }">
							<v-icon v-if="item.children && item.children.length !== 0">
								mdi-flag
							</v-icon>
						</template>        
					</v-treeview>
				</div>
			</v-card>
			<v-row class="ma-0">
				<v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 6" class="pl-0 py-0">
					<v-btn block outlined class="text-capitalize" color="#82899B" @click="onBack()">
						Cancel changes
					</v-btn>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 6" class="pr-0 py-0">
					<v-btn block elevation="0" class="text-capitalize white--text" color="#82899B">
						Save changes
					</v-btn>
				</v-col>
			</v-row>
		</v-card>
	</div>
</template>

<script>
import moment from 'moment';

const Recurrences = [
	{
		key: 'same',
		text: 'Same Date every year',
		value: 0,
		comment: 'Use this recurrence type if the Public Holiday happens on the same Day and Month every year. Select the Day and Month for this Public Holiday below. '
	},
	{
		key: 'different',
		text: 'Different Date every year',
		value: 1,
		comment: '?'
	},
	{
		key: 'day',
		text: '(Nth Day) of (Month) every year',
		value: 2,
		comment: '?'
	}
];
const MonthList = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December'
];


export default {
	name: 'HolidayDetail',
	props: {
		holiday: {
			type: Object,
			default: () => {}
		},
		color: {
			type: String,
			default: ''
		},
		isDuplicate: {
			type: Boolean,
			default: false
		}
	},
	data() {
		this.recurrences = Recurrences;
		this.month_list = MonthList;

		return {
			holiday_name: this.holiday ? this.holiday.name : '',
			holiday_recurrency: this.holiday ? this.holiday.recurrence : 0,

			holiday_month: this.holiday ? moment(this.holiday.date).format('MMMM') : moment().format('MMMM'),
			holiday_day: this.holiday ? moment(this.holiday.date).format('D') : moment().format('D'),
			is_recurrences: true,
			is_move_next: true,
			country_select: '',

			open: [],
			select_country_items: [],
			country_items: [
				{
					id: 101,
					name: 'Applications',
					children: [
						{ id: 102, name: 'Calendar' },
						{ id: 103, name: 'Chrome' },
						{ id: 104, name: 'Webstorm' },
					],
				},
				{
					id: 201,
					name: 'Applications',
					children: [
						{ id: 202, name: 'Calendar' },
						{ id: 203, name: 'Chrome' },
						{ id: 204, name: 'Webstorm' },
					],
				},
				{
					id: 301,
					name: 'Applications',
					children: [
						{ id: 302, name: 'Calendar' },
						{ id: 303, name: 'Chrome' },
						{ id: 304, name: 'Webstorm' },
					],
				},
			],
			

		};
	},
	computed: {
		days() {
			let days_tmp = [];

			const days = moment(this.holiday_month, 'MMMM').daysInMonth();
			for (let index = 1; index < days + 1; index++) {
				days_tmp.push(index.toString());
			}

			return days_tmp;
		}
	},
	methods: {
		onBack() {
			this.$emit('back')
		},
		onSelectAll() {
			this.country_items.forEach(c => {
				if (c.children && c.children.length !== 0) {
					c.children.forEach(child => {
						this.select_country_items.push(child);
					})
				}
			});
		},
		onDeselectAll() {
			this.select_country_items = [];
		},
		onExpandAll() {
			this.country_items.forEach(c => {
				this.open.push(c);
			});
		},
		onCollapseAll() {
			this.open = [];
		},
		remove(item) {
			this.select_country_items = this.select_country_items.filter(a => { return a.id !== item.id });
		}
	}
}
</script>
<style lang="scss" scoped>
.title-text {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #37495F;
}
.comment-text {
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.4px;
  color: #37495F;
}
.text-color {
  color: #82899B;
}
</style>